import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client'

const GET_INSTITUTION_POSITION = gql`
  query InstitutionHoldingCurrent(
      $tickerId: [String]! 
      $entityId: [String]!
      $source: String!
    ) {
    instHoldingCurrent(
      tickerId: $tickerId 
      institutionId: $entityId
      source: $source
      ) {
      items {
        current
      }
    }
  }`

/**
 * Current Position
 * @param options
 */
export function usePositionQuery (options) {
  return useQuery(GET_INSTITUTION_POSITION, options)
}
